import React, { useState } from "react";
import { Spinner } from "reactstrap";
import { checkSystemAdmin, URL } from "../../utils/Constants";
import { axiosPost } from "../../utils/AxiosApi";
import swal from "sweetalert";

const UserTableRow = ({
  user,
  handleInputChange,
  firstLoginUsers,
  checkSystemAdminInList,
  toggleForgotModal,
  enableDisableUser,
  toggleRolesModal,
  togglePermissionsModal,
  clearCheckedInput,
  userManager,
}) => {
  const [loading, setLoading] = useState(false);

  const generateCredentials = (params) => {
    setLoading(true);
    axiosPost(
      URL.generateCredentials,
      params,
      (response) => {
        if (response.status === 200) {
          setLoading(false);

          const url = response.data.path;
          const path = url.startsWith("/") ? url.slice(1) : url;
          window.open(URL.fileDownloadURL + path, "_blank");

          clearCheckedInput();
        }
      },
      (error) => {
        setLoading(false);
        swal("Oops", "Failed to generate credentials");
      },
    );
  };

  const handleResendCredential = (e) => {
    const id = Number(e.target.id);
    if (!id) {
      return;
    }

    // if (!firstLoginUsers[id]) {
    //   swal("Error", "Please select the user first");
    //   return;
    // }

    generateCredentials([id]);
  };
  return (
    <tr>
      <td>
        <input
          type="checkbox"
          id={user.id}
          disabled={!user.isFirstLogin}
          onChange={handleInputChange}
          checked={firstLoginUsers[user.id] || false}
        />
      </td>
      <td>{user.peopleName}</td>
      <td>{user.username}</td>
      {userManager && <td>{user.schoolName ?? "N/A"}</td>}
      <td>{user.userRole}</td>
      <td className="text-center">
        {checkSystemAdmin() && checkSystemAdminInList(user) ? null : (
          <>
            <button
              style={{ width: "165px" }}
              onClick={handleResendCredential}
              id={user.id}
              className="tt-button tt-button-primary mr-3"
              disabled={!user.isFirstLogin || loading}
            >
              {loading ? (
                <Spinner size={"sm"} color="white"></Spinner>
              ) : (
                "Resend Credential"
              )}
            </button>

            <button
              className="tt-button tt-button-primary mr-3"
              onClick={() => toggleForgotModal(user.username, user.id)}
            >
              Update Password
            </button>
            <button
              className="tt-button tt-button-primary"
              onClick={() => enableDisableUser(user.id, !user.enabled)}
            >
              {user.enabled ? "Disable User" : "Enable User"}
            </button>
            <button
              className="tt-button tt-button-primary"
              onClick={() => toggleRolesModal(user)}
            >
              Roles
            </button>
            <button
              className="tt-button tt-button-primary"
              onClick={() => togglePermissionsModal(user)}
            >
              Permissions
            </button>
          </>
        )}
      </td>
    </tr>
  );
};
export default UserTableRow;
